import { render, staticRenderFns } from "./bandEmail.vue?vue&type=template&id=ec99140e&scoped=true"
import script from "./bandEmail.vue?vue&type=script&lang=js"
export * from "./bandEmail.vue?vue&type=script&lang=js"
import style0 from "./bandEmail.vue?vue&type=style&index=0&id=ec99140e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_5qbk3fxidqh42wxgbx7uqb2gxe/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec99140e",
  null
  
)

export default component.exports